<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Orders</h2>
          </header>
        </div>
      </div>
      <div class="inputCard">
        <header>Orders</header>
        <div class="content">
          <template v-if="state.siteData.content.products.orders && state.siteData.content.products.orders.length > 0">
            <div class="orderRow w3-border-bottom">
              <div class="orderCol"><b>ID</b></div>
              <div class="orderCol"><b>Email</b></div>
              <div class="orderCol"><b>Customer</b></div>
              <div class="orderCol"><b>Purchase Date</b></div>
              <div class="orderCol"><b>Expected</b></div>
              <div class="orderCol"><b>Payment Status</b></div>
              <div class="orderCol"><b>Order Total</b></div>
              <div class="orderCol"><b>Status</b></div>
            </div>
            <div class="orderRow itemRow" v-for="(item, index) in state.siteData.content.products.orders" :key="index" @click="viewOrder(item.id)">
              <div class="orderCol">{{item.id}}</div>
              <div class="orderCol">{{item.billingAddress.email}}</div>
              <div class="orderCol">{{item.billingAddress.firstname}} {{item.billingAddress.lastname}}</div>
              <div class="orderCol">{{timeConverter(item.purchase_date)}}</div>
              <div class="orderCol">{{item.shipping.days}} day(s)</div>
              <div class="orderCol">{{item.payment_status}}</div>
              <div class="orderCol">{{item.total / 100 | currency}}</div>
              <div class="orderCol">
                <select name="order-status" v-model="item.status" class="form-control" v-on:click.stop="" @change="changeStatus(item, $event)">
                  <option v-for="(statusItem, index) in statusList" :value="statusItem" :key="index">{{statusItem}}</option>
                </select>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="w3-container">
              <p>No Orders found.</p>
            </div>
          </template>
        </div>
      </div>
      <!-- <div class="inputCard">
        <header>Pending</header>
        <div class="content">
          Test
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsproductorders',
  data() {
    return {
      state: dataStore.state,
      newCategory: {
        id: 0,
        title: '',
        image: '',
        parentid: 0,
        slug: ''
      },
      activePage: 1,
      interval: null,
      statusList: [
        'new',
        'shipped',
        'returned',
        'completed',
      ],
      selectedStatus: {}
    }
  },
  created() {
    dataStore.getOrders()
    this.interval = setInterval(() => {
      dataStore.getOrders()
    }, 60000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    gotoPage(page) {
      if (page === '-1') {
        if (this.activePage > 1) {
          this.activePage--
        }
      } else if (page === '+1') {
        if (this.activePage < Math.ceil(this.state.siteData.content.products.items.length / 9)) {
          this.activePage++
        }
      } else {
        this.activePage = page
      }
    },
    setParent(parent) {
      this.newCategory.parentid = parent.id
    },
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    viewOrder(id) {
      dataStore.state.selectedOrder = id
      this.$router.push('/cms/order-detail')
    },
    changeStatus(item, event) {
      item.status = event.target.value
      for (let orderItem of this.state.siteData.content.products.orders) {
        if (orderItem.id === item.id) {
          orderItem = item
          break
        }
      }
      this.saveContent()
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000)
      var options = {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      }
      var time = a.toLocaleString('en-US', options)
      return time
    }
  }
}
</script>

<style scoped>
  .orderRow {display:grid; grid-template-columns: 80px 250px 200px 1fr 100px 130px 120px 150px; grid-gap:8px; font-family: 'Roboto';}
  .orderRow .orderCol {padding:4px 8px; align-self: center;}
  .itemRow:nth-child(even) {background:#eee;}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsProductOrders.vue